export enum DealTypeEnum {
  Sale = 'sale',
  Rent = 'rent',
  RealStateParent = 'real_estate_parent', // to lancamento on search url
}
